<template>
    <OnboardingLayout v-bind="appSharedData.getOnboardingLayoutProps()">
        <template #content>
            <OnboardingStepContainer
                :showStepsIndicator="true"
                :stepNumber="2"
            >
                <template #title>What do people book you for?</template>
                <template #subtitle>
                    Choose the option that is closest. We'll use it to
                    personalize your setup and create your first service.
                </template>
                <template #content>
                    <ApiForm
                        method="POST"
                        :url="RoutePathAppEnum.Onboarding_Step2_BookingReason"
                        ref="apiFormRef"
                        class="w-full"
                    >
                        <input
                            type="hidden"
                            :name="
                                RequestBodyKeyEnum.App_Onboarding_BookingReason
                            "
                            :value="dummySelectedBookingReason"
                        />

                        <div class="space-y-8">
                            <FormControl
                                hideLabel
                                :error="
                                    apiFormRef?.response?.getValidationError(
                                        RequestBodyKeyEnum.App_Onboarding_BookingReason,
                                    )
                                "
                            >
                                <div class="grid grid-cols-12 gap-4">
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.DiscoveryCalls
                                            "
                                            iconName="comments"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .DiscoveryCalls
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .DiscoveryCalls
                                                ].description
                                            "
                                        />
                                    </div>
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.CoachingSessions
                                            "
                                            iconName="user-group"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .CoachingSessions
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .CoachingSessions
                                                ].description
                                            "
                                        />
                                    </div>
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.ConsultingSessions
                                            "
                                            iconName="briefcase"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .ConsultingSessions
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .ConsultingSessions
                                                ].description
                                            "
                                        />
                                    </div>
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.StrategyCalls
                                            "
                                            iconName="compass"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .StrategyCalls
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .StrategyCalls
                                                ].description
                                            "
                                        />
                                    </div>
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.OfficeHours
                                            "
                                            iconName="door-open"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .OfficeHours
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .OfficeHours
                                                ].description
                                            "
                                        />
                                    </div>
                                    <div
                                        class="col-span-12 md:col-span-6 lg:col-span-4"
                                    >
                                        <OnboardingStepBookingReasonItemCard
                                            v-model="dummySelectedBookingReason"
                                            @update:modelValue="
                                                handleBookingReasonSelected
                                            "
                                            :reason="
                                                BookingReasonEnum.PaidAppointments
                                            "
                                            iconName="credit-card-solid"
                                            :title="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .PaidAppointments
                                                ].label
                                            "
                                            :description="
                                                BookingReasonEnumData[
                                                    BookingReasonEnum
                                                        .PaidAppointments
                                                ].description
                                            "
                                        />
                                    </div>
                                </div>
                            </FormControl>
                            <div>
                                <div class="text-gray-600">
                                    Or describe your use case in 1-3 words:
                                </div>
                                <div class="w-full lg:w-1/2">
                                    <FormControl
                                        hideLabel
                                        :error="
                                            apiFormRef?.response?.getValidationError(
                                                RequestBodyKeyEnum.App_Onboarding_BookingReasonDescription,
                                            )
                                        "
                                    >
                                        <TextInput
                                            :name="
                                                RequestBodyKeyEnum.App_Onboarding_BookingReasonDescription
                                            "
                                            v-model="
                                                dummyBookingReasonDescription
                                            "
                                            @focus="
                                                handleBookingReasonDescriptionFocused
                                            "
                                            placeholder="Ex: Portfolio reviews, tax advisory, podcast booking"
                                        />
                                    </FormControl>
                                </div>
                            </div>
                        </div>
                    </ApiForm>
                </template>
            </OnboardingStepContainer>
        </template>

        <template #footerRight>
            <Button
                @click="apiFormRef?.submit()"
                iconName="arrow-right"
                color="primary"
                :iconRight="true"
                :loading="apiFormRef?.loading.valueOf()"
            >
                Continue
            </Button>
        </template>
    </OnboardingLayout>
</template>

<script setup lang="ts">
    import { ref } from 'vue'
    import OnboardingLayout from '@/Shared/Layout/Onboarding/OnboardingLayout.vue'
    import Button from '@/Shared/Component/Button.vue'
    import ApiForm from '@/Shared/Component/Forms/ApiForm.vue'
    import OnboardingStepContainer from '@/App/Company/Component/OnboardingStepContainer.vue'
    import type { ApiFormRefType } from '@/Shared/AutoGenerated/Types'
    import AppSharedData from '@/Shared/Entity/AppSharedData'
    import Onboarding from '@/App/Company/Entity/Onboarding'
    import { RoutePathAppEnum } from '@/Shared/AutoGenerated/RoutePathEnum'
    import {
        BookingReasonEnum,
        BookingReasonEnumData,
        type OnboardingRawData,
    } from '@/Shared/AutoGenerated/Main'
    import { RequestBodyKeyEnum } from '@/Shared/AutoGenerated/RequestFieldEnum'
    import OnboardingStepBookingReasonItemCard from '@/App/Company/Component/OnboardingStepBookingReasonItemCard.vue'
    import FormControl from '@/Shared/Component/Forms/FormControl.vue'
    import TextInput from '@/Shared/Component/Forms/TextInput.vue'

    interface ShowOnboardingStepBookingReasonProps {
        appSharedDataData: any
        onboardingRawData: OnboardingRawData
    }

    const props = defineProps<ShowOnboardingStepBookingReasonProps>()
    const appSharedData = AppSharedData.hydrate(props.appSharedDataData)
    const onboarding = Onboarding.hydrateSingle(props.onboardingRawData)
    const apiFormRef = ref<ApiFormRefType>(null)

    const dummySelectedBookingReason = ref<BookingReasonEnum | undefined>(
        onboarding.surveyBookingReason ?? undefined,
    )
    const dummyBookingReasonDescription = ref<string | null>(
        onboarding.surveyBookingReasonDescription,
    )

    const handleBookingReasonDescriptionFocused = () => {
        dummySelectedBookingReason.value = undefined
    }

    const handleBookingReasonSelected = () => {
        dummyBookingReasonDescription.value = null
    }
</script>
